export enum FoxpostOrderStatus {
    SHIPMENT_AWAITING = 'SHIPMENT_AWAITING',
    PARCEL_CREATED = 'PARCEL_CREATED',
}
